export const planetFacts = {
  mercury: [
    "Merkurius adalah planet terdekat dengan Matahari dan mengelilinginya sangat cepat.",
    "Suhu di Merkurius bisa sangat panas di siang hari dan sangat dingin di malam hari.",
    "Merkurius tidak memiliki atmosfer tebal sehingga panas mudah hilang.",
    "Satu hari di Merkurius terasa sangat panjang dibandingkan satu harinya di Bumi.",
    "Merkurius tidak memiliki bulan yang mengelilinginya.",
    "Permukaan Merkurius penuh kawah dan mirip dengan permukaan Bulan.",
    "Merkurius adalah planet terkecil di seluruh tata surya.",
    "Langit Merkurius tampak gelap karena hampir tidak ada atmosfer.",
    "Gravitasi Merkurius lebih lemah sehingga benda terasa lebih ringan.",
    "Merkurius bergerak sangat cepat saat mengelilingi Matahari."
  ],

  venus: [
    "Venus adalah planet terpanas karena atmosfernya menjebak panas.",
    "Venus sering disebut saudara kembar Bumi karena ukurannya hampir sama.",
    "Arah putaran Venus berlawanan dengan sebagian besar planet lain.",
    "Atmosfer Venus sangat tebal dan penuh dengan awan beracun.",
    "Venus terlihat sangat terang dan sering disebut bintang fajar.",
    "Tidak ada air cair di permukaan Venus karena suhunya sangat panas.",
    "Satu hari di Venus lebih lama dibandingkan satu tahun di planet itu.",
    "Venus tidak memiliki bulan yang menemani orbitnya.",
    "Awan di Venus mengandung asam yang sangat berbahaya.",
    "Permukaan Venus dipenuhi gunung api dan dataran luas."
  ],

  earth: [
    "Bumi adalah satu-satunya planet yang diketahui mendukung kehidupan.",
    "Sebagian besar permukaan Bumi tertutup oleh lautan air.",
    "Bumi memiliki satu bulan yang memengaruhi pasang surut laut.",
    "Atmosfer Bumi melindungi makhluk hidup dari benda luar angkasa.",
    "Gravitasi Bumi pas sehingga manusia bisa hidup dengan nyaman.",
    "Bumi berputar sekali setiap 24 jam sehingga terjadi siang dan malam.",
    "Bumi mengelilingi Matahari selama satu tahun penuh.",
    "Medan magnet Bumi melindungi dari radiasi berbahaya Matahari.",
    "Bumi memiliki beragam tumbuhan, hewan, dan manusia.",
    "Suhu Bumi memungkinkan air tetap dalam bentuk cair."
  ],

  mars: [
    "Mars dikenal sebagai Planet Merah karena debu besinya.",
    "Mars memiliki dua bulan kecil bernama Phobos dan Deimos.",
    "Mars memiliki gunung terbesar di tata surya bernama Olympus Mons.",
    "Udara di Mars sangat tipis sehingga sulit untuk bernapas.",
    "Mars diyakini pernah memiliki air di masa lalu.",
    "Mars lebih dingin dari Bumi karena jaraknya dari Matahari.",
    "Hari di Mars hampir sama lamanya dengan hari di Bumi.",
    "Mars sering diteliti oleh robot dan wahana antariksa.",
    "Langit Mars terlihat kemerahan karena debu di udaranya.",
    "Manusia bermimpi suatu hari bisa menjelajahi Mars."
  ],

  jupiter: [
    "Jupiter adalah planet terbesar di tata surya.",
    "Jupiter memiliki badai raksasa yang sudah berlangsung lama.",
    "Jupiter memiliki banyak bulan yang mengorbit di sekitarnya.",
    "Jupiter disebut raksasa gas karena sebagian besar terdiri dari gas.",
    "Gravitasi Jupiter sangat kuat dan menarik banyak benda.",
    "Jupiter memiliki cincin tipis yang sulit terlihat.",
    "Badai besar Jupiter sudah ada selama ratusan tahun.",
    "Jupiter membantu melindungi planet dalam dari asteroid.",
    "Jupiter berputar sangat cepat dibandingkan planet lain.",
    "Jupiter terlihat terang di langit malam."
  ],

  saturn: [
    "Saturnus terkenal dengan cincin indah yang mengelilinginya.",
    "Cincin Saturnus terbuat dari es dan batu kecil.",
    "Saturnus adalah planet raksasa gas yang sangat besar.",
    "Saturnus memiliki banyak bulan dengan bentuk unik.",
    "Saturnus bisa mengapung jika ada air sebesar itu.",
    "Saturnus memiliki ukuran yang sangat besar dibandingkan Bumi.",
    "Angin di Saturnus bisa bertiup sangat kencang.",
    "Saturnus berwarna kuning pucat dan terlihat lembut.",
    "Saturnus berotasi dengan sangat cepat.",
    "Saturnus memiliki medan magnet yang kuat."
  ],

  uranus: [
    "Uranus berputar miring seperti bola yang terguling.",
    "Uranus berwarna biru kehijauan karena gas metana.",
    "Uranus adalah salah satu planet paling dingin.",
    "Uranus termasuk planet raksasa es.",
    "Uranus memiliki cincin tipis yang mengelilinginya.",
    "Uranus memiliki banyak bulan dengan ukuran berbeda.",
    "Uranus sulit dilihat dengan mata telanjang.",
    "Uranus berputar dari samping saat mengelilingi Matahari.",
    "Atmosfer Uranus mengandung gas metana.",
    "Uranus berada sangat jauh dari Matahari."
  ],

  neptune: [
    "Neptunus adalah planet terjauh dari Matahari.",
    "Neptunus berwarna biru karena gas di atmosfernya.",
    "Angin di Neptunus adalah yang tercepat di tata surya.",
    "Neptunus termasuk planet raksasa es.",
    "Neptunus memiliki suhu yang sangat dingin.",
    "Neptunus memiliki cincin yang tipis dan redup.",
    "Neptunus sering mengalami badai besar.",
    "Neptunus sulit ditemukan tanpa teleskop.",
    "Neptunus membutuhkan waktu sangat lama mengelilingi Matahari.",
    "Neptunus memiliki banyak bulan yang unik."
  ]
};
